import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const aiProactivePluginKey = new PluginKey('aiProactivePlugin');
